import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllFeatureUpdates(_obj, params) {
    const res = await axios.get(`api/app_updates/`, { params });
    return res.data;
  },

  async getFeatureUpdate(_obj, id) {
    const res = await axios.get(`api/app_updates/${id}/`);
    return res.data;
  },

  async updateFeatureUpdate(_obj, { id, data }) {
    return axios.patch(`api/app_updates/${id}/`, data);
  },

  async createFeatureUpdate(_obj, data) {
    const res = await axios.post(`api/app_updates/`, data);
    return res.data;
  }
};

export const featureUpdates = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
